export const INVITE_MEMBER_DESCRIPTION_TEXT_1 =
  "By inviting users, you're bringing your team members into the system, enabling them to join teams, take part in TEAMscan surveys, and receive personalized insights and reports.";
